/* unplugin-vue-components disabled */import { render } from "./base-table.vue?vue&type=template&id=108b0f76&scoped=true"
import script from "./base-table.vue?vue&type=script&lang=js"
export * from "./base-table.vue?vue&type=script&lang=js"

import "./base-table.vue?vue&type=style&index=0&id=108b0f76&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108b0f76"]])

export default __exports__